export enum LoginMethod {
  SSO = 'SSO',
  BBID = 'BBID',
  Impersonate = 'Impersonate'
}